import {createI18nScope} from 'common/i18n/scope';

const __i18nScope = createI18nScope(`gdpr.banner`, {
  'gdpr-banner.accept': `Accept`,
  'gdpr-banner.cookie-policy': `cookie policy`,
  'gdpr-banner.cookies-message': `Mixpanel uses cookies to run our site and improve its functionalities for a better browsing experience. To learn more about Mixpanel's use of cookies please review our`,
  'gdpr-banner.decline': `Decline`,
  'gdpr-banner.legacy-agreement': `. By using our services you agree to the use of cookies and to the collection of your personal information.`,
  'gdpr-banner.legacy-cookies-intro': `Mixpanel uses cookies to make it easier for you to use our website; read more about our `,
  'gdpr-banner.legacy-privacy-intro': `. We will also collect personal information about you as described in our `,
  'gdpr-banner.privacy-policy': `Privacy Policy`,
  'gdpr-banner.privacy-statement': `privacy statement`,
  'gdpr-banner.reject': `Reject`,
});

__i18nScope.registerTranslationLoaders({"es": () => import("virtual:i18n-scope/es/gdpr.banner"), "fr": () => import("virtual:i18n-scope/fr/gdpr.banner"), "id": () => import("virtual:i18n-scope/id/gdpr.banner"), "ja": () => import("virtual:i18n-scope/ja/gdpr.banner"), "ko": () => import("virtual:i18n-scope/ko/gdpr.banner"), "pt": () => import("virtual:i18n-scope/pt/gdpr.banner"), "zh-CN": () => import("virtual:i18n-scope/zh-CN/gdpr.banner"), "zh-TW": () => import("virtual:i18n-scope/zh-TW/gdpr.banner")});
export default __i18nScope;
